const initialState = {
    projectTimeLogs: [],
    employeeTimeLogs: []
}

export const projectTimeLogsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_ALL_TIME_LOGS':
            return {
                ...state,
                employeeTimeLogs: action?.payload.timeLogs,
                employeeAttendance: action?.payload.attendance
            };
        case 'GET_ALL_PROJECT_TIME_LOGS':
            return {
                ...state,
                projectTimeLogs: action?.payload.timeLogs,
                employeesAttendance: action?.payload.attendance
            };
        default:
            return {
                ...state
            }
    }
}

export default projectTimeLogsReducer;